import { render } from "./PLSReceive.vue?vue&type=template&id=487b834a&scoped=true"
import script from "./PLSReceive.vue?vue&type=script&lang=js"
export * from "./PLSReceive.vue?vue&type=script&lang=js"

import "./PLSReceive.vue?vue&type=style&index=0&id=487b834a&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487b834a"]])

export default __exports__